import { useEqMemoize } from './useEqMemoize';
import { useMemo } from 'react';
export var useStableMemo = function (factory, dependencies, eq, options) {
    return useMemo(factory, useEqMemoize(dependencies, eq, options));
};
//# sourceMappingURL=memo.js.map